<template>
  <v-dialog v-model="displayFlag" width="500" persistent>
    <v-card>
      <v-card-title class="headline red white--text" primary-title>
        {{ $vuetify.t('$vuetify.calls.proximityWarningHeader') }}
      </v-card-title>
      <v-card-text>
        {{
          $vuetify.t('$vuetify.calls.proximityWarningBody', [
            this.formattedDistance
          ])
        }}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="primary" flat @click.native="displayFlag = false">
          {{ $vuetify.t('$vuetify.app.cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="red" flat @click="confirmProximity">
          {{ $vuetify.t('$vuetify.calls.proximityConfirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import formatting from '../mixins/formatting.js'

export default {
  name: 'ProximityDialog',
  mixins: [formatting],
  data: () => ({
    displayFlag: false
  }),
  props: ['distanceToSite'],
  mounted() {},
  methods: {
    show: function() {
      this.displayFlag = true
    },
    hide: function() {
      this.displayFlag = false
    },
    confirmProximity: function() {
      this.$emit('accept-proximity-warning')
    }
  },
  computed: {
    formattedDistance() {
      return this.formatMetresToMiles(this.distanceToSite)
    }
  }
}
</script>
